import { render } from "./CustomTa2.vue?vue&type=template&id=2cfcb765"
import script from "./CustomTa2.vue?vue&type=script&lang=js"
export * from "./CustomTa2.vue?vue&type=script&lang=js"

import "./CustomTa2.vue?vue&type=style&index=0&id=2cfcb765&lang=css"

import exportComponent from "/home/runner/work/corpsales-services/corpsales-services/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__